

import { Login } from '@/models/login'
import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'

export default {

  setup(props){
    const router = useRouter();
    const login = ref({} as Login);
    const store = useStore();
    const toast = useToast();

    const valid = computed(()=> login.value.password && login.value.username);

    const doLogin = () => {
      AuthRepository.userPermission(login.value)
        .then((responses)=>{
          store.dispatch('setPermission', responses.data.permission)
          store.dispatch('setTeam', responses.data.team)
        })
        .catch(() => {
        });
      AuthRepository.auth(login.value)
        .then((response)=>{
          store.dispatch('setToken', response.data.token)
          toast.add({
            severity:'success',
            summary: 'Đăng nhập',
            detail:'Đăng nhập thành công vào hệ thống',
            life: 1000
          });
          router.push({
            name: 'home'
          });
        })
        .catch(() => {
          toast.add({
            severity:'error',
            summary: 'Đăng nhập',
            detail:'Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin đăng nhập',
            life: 1000
          });
        });
    }

    return {
      login,
      doLogin,
      valid
    }
  }
}

